import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Update with the correct import
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const AddParcel = () => {
    const [name, setName] = useState('');
    const [amount, setAmount] = useState('');
    const [status, setStatus] = useState('pending');
    const [image, setImage] = useState(null); // For storing the image file
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file); // Set the selected image file
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrorMessage(''); // Reset error message before trying to submit again

        const formData = new FormData();
        formData.append('name', name);
        formData.append('amount', amount);
        formData.append('status', status);
        if (image) {
            formData.append('image', image); // Append image to form data
        }

        // Use FormData to submit files and data
        fetch(`${BASE_URL}parcel/`, {
            method: 'POST',
            body: formData,
        })
            .then(response => {
                console.log('Response Status:', response.status);
                // Check if the response is okay (status 200-299)
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                setIsSubmitting(false);
                if (data.status === 1) {
                   Swal.fire({
                     icon: "success",
                     title: "Parcel created successfully!",
                   });
                    navigate('/ParcelList'); // Redirect to the Parcel List page after success
                } else {
                    console.error('Error creating parcel:', data.message);
                    setErrorMessage(data.message || 'Failed to create parcel. Please try again.');
                    alert('Failed to create parcel. Please try again.');
                }
            })
            .catch(error => {
                setIsSubmitting(false);
                console.error('Error creating parcel:', error);
                // Improved error message logging
                setErrorMessage(error.message || 'An unexpected error occurred. Please try again.');
                alert(error.message || 'An error occurred. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Parcel</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Amount</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Submitting...' : 'Add Parcel'}
                            </button>&nbsp;
                             <button
        type="button"
        className="btn btn-secondary"
        onClick={() => navigate('/ParcelList')}
    >
        Back
    </button>
                        </form>

                        {/* Display the error message if there is one */}
                        {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddParcel;
